import FeatureGridItem from '../components/feature-grid-item'
import Grid from '../components/grid'
import Container from '../components/ui/container'
import { Page } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'

export type BlockProps = Extract<Page['blocks'][0], { blockType: 'dual-column-features-grid' }>

export default function DualColumnFeaturesGrid(block: BlockProps): ReactElement {
  const { items, options } = block

  let hexColour: string | undefined
  switch (options?.background) {
    case 'default':
      hexColour = '#1ea1dc'
      break
    case 'custom':
      hexColour = options?.customColour
      break
    default:
      hexColour = '#1ea1dc'
      break
  }

  const hideDescription = options?.hideDescription ?? false

  return (
    <Container>
      <Grid>
        {items &&
          items.map((option: any, idx: number) => (
            <FeatureGridItem
              key={`features--key-${option.id}`}
              idx={idx}
              title={option.title}
              background={hexColour}
              description={option.description}
              image={option.image}
            />
          ))}
      </Grid>
    </Container>
  )
}
